<template>
  <div>

    <div class="calendario-main" v-if="type=='main'">
      <div class="calendario-titulo">
        <h3>Plenárias principais</h3>
      </div>
      <div class="calendario-container">
        <div class="calendario-navegacao d-flex">
          <div class="calendario-horas">
            <div class="horas-initial-spacer">
            </div>
            <div class="calendario-hora" v-for="(horario, index) in horarios" :key="index"
                :style="{
                    'height': (baseHeight*horario.size)+'px'
                  }">

              <span v-html='horario.horaTxt'></span>
            </div>
          </div>
          <div class="calendario-eventos flex-fill">
            <div class="calendario-eventos-container d-flex">

              <div class="calendario-track" v-for="(palco, index) in palcos" :key="index">
                <div class="calendario-track-titulo">
                  <h4 class="flex-fill">{{index+1}} - <span v-html='palco.title'></span></h4>
                </div>
                <div class="calendario-track-eventos">

                  <div class="evento" v-for="(talk,index) in getTalksByTrack(palco)" :key="index" 
                  :style="{
                    'top': topPositionEvento(talk),
                    'height': heightEvento(talk)
                  }" :class="{'user-talk':userHaveTalk(talk)||talk.talkAdded}">

                    <div class='event-card' @click="openTalk(talk)">
                      <div class='event-card-title-container'>
                        <div class='event-card-title flex-fill'>
                          <h4>Palestra</h4>
                          <h5>{{talk.title}}</h5>
                        </div>
                        <div class='event-cta'>
                          <i class="fas fa-plus-circle" @click.stop="addUserTalk(talk)" title="Adicionar evento na sua agenda" v-b-tooltip.hover v-if="!userHaveTalk(talk)"></i>
                          <i class="fas fa-minus-circle text-white" @click.stop="removeUserTalk(talk)" title="Remover evento da sua agenda" v-b-tooltip.hover v-else></i>
                        </div>
                      </div>
                      <div class='event-card-speakers'>
                        <div class='single-speaker-card' v-for="(speaker, index) in talk.speakers" :key="index">
                          <div class='speaker-avatar'><img :src='speaker.photo' class='avatar'></div>
                          <div class='speaker-info'>
                            <p class='speaker-name'>{{speaker.name}}</p>
                            <p class='speaker-cargo-empresa'>{{speaker.job_title}} - {{speaker.company}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>


                <div class="evento event-marker d-block d-md-none" v-for='(intervalo, index) in intervalos' :key='index+"a"' :style="{
                  'top': topPositionIntervalo(intervalo),
                  'height': heightIntervalo(intervalo)
                }">
                  <div class="event-card">
                    <h5 class="text-center">{{intervalo.horaTxt}}</h5>
                  </div>
                </div>


              </div>


              <div class="evento event-marker d-none d-md-block" v-for='(intervalo, index) in intervalos' :key='index+"a"' :style="{
                'top': topPositionIntervalo(intervalo),
                'height': heightIntervalo(intervalo)
              }">
                <div class="event-card">
                  <h5 class="text-center">{{intervalo.horaTxt}}</h5>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>

    </div> <!-- end .calendario-main -->



    <div class="calendario-secondary" v-if="type=='secondary'">
      <div class="calendario-titulo">
        <h3>Conteúdo Adicional</h3>
      </div>

        <div class="calendario-container">
          <div class="calendario-eventos-container">
            <div class="calendario-track" v-for="(palco, index) in palcosByName" :key="index">
                <div class="calendario-track-titulo">
                  <h4 class="flex-fill"><span v-html='palco.title'></span></h4>
                </div>
                <div class="calendario-track-eventos">
                  <div class="evento" v-for="(talk,index) in getTalksByTrack(palco)" :key="index" 
                   :class="{'user-talk':userHaveTalk(talk)}">

                    <div class='event-card' @click="openTalk(talk)" v-if='!talk.isFullDay'>
                      <div class="event-time-container">
                        <div class="event-time">
                          <p>{{talk.date_start|formatTimeFromDate}}</p>
                          <p>às</p>
                          <p>{{talk.date_end|formatTimeFromDate}}</p>
                        </div>
                      </div>
                      <div class="event-info flex-fill">
                        <div class='event-card-title-container'>
                          <div class='event-card-title flex-fill'>
                            <h4>Palestra</h4>
                            <h5>{{talk.title}}</h5>
                          </div>
                          <div class='event-cta'>
                            <i class="far fa-calendar" @click.stop="addUserTalk(talk)" title="Adicionar evento na sua agenda" v-b-tooltip.hover v-if="!userHaveTalk(talk)"></i>
                            <i class="fas fa-minus-circle text-white" @click.stop="removeUserTalk(talk)" title="Remover evento da sua agenda" v-b-tooltip.hover v-else></i>
                          </div>
                        </div>
                        <div class='event-card-speakers'>
                          <div class='single-speaker-card' v-for="(speaker, index) in talk.speakers" :key="index">
                            <div class='speaker-avatar'><img :src='speaker.photo' class='avatar'></div>
                            <div class='speaker-info'>
                              <p class='speaker-name'>{{speaker.name}}</p>
                              <p class='speaker-cargo-empresa'>{{speaker.job_title}} - {{speaker.company}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="event-card fullday" v-else>
                      <div class="event-info">
                        <div class="event-card-title">
                          <h5>{{talk.title}}</h5>
                        </div>
                        <div class="event-card-description" v-html="talk.description">

                        </div>
                        <div class='event-card-speakers'>
                          <div class='single-speaker-card' v-for="(speaker, index) in talk.speakers" :key="index">
                            <div class='speaker-avatar'><img :src='speaker.photo' class='avatar'></div>
                            <div class='speaker-info'>
                              <p class='speaker-name'>{{speaker.name}}</p>
                              <p class='speaker-cargo-empresa'>{{speaker.job_title}} - {{speaker.company}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="event-cta text-center" v-if="talk.video_link">
                          <a :href="talk.video_link" target="_blank" class="btn btn-success">Saiba mais</a>
                        </div>

                      </div>
                    </div>


                  </div>
                </div>
            </div>
          </div>
        </div>

    </div>  <!-- end .calendario-secondary -->


    <div class="calendario-sponsor" v-if="type=='sponsor'">
      <div class="calendario-titulo">
        <h3>Salas de Conteúdo de Patrocinadores</h3>
      </div>

      <div class="tracks">
        <div class="row">
          <div class="sponsor-track col-md-2 col-4"  v-for="(palco, index) in palcosByName" :key="index">
            <div class="sponsor-track-card" @click="openModalTrackTalks(palco, dia)">
              <img :src="palco.metas.image[0]" :alt="palco.title" :title="palco.title" class="img-fluid px-3 px-md-0">
            </div>
          </div>
        </div>
      </div>

    </div> <!-- end .calendario-sponsor -->

    <ModalTalk ref="ModalTalk" />
    <ModalTrackTalks ref="ModalTrackTalks" />

  </div>
</template>
<script>

  import ModalTalk from '../components/ModalTalk'
  import ModalTrackTalks from '../components/ModalTrackTalks'
  import _ from 'lodash'

  export default{
      components: {
        ModalTalk,
        ModalTrackTalks
      },
      props: ['talks', 'palcos', 'dia', 'type'],
      data() {
        return {
            id: "",
            isRestricted: process.env.VUE_APP_RESTRICT_VIEW=="false"?false:true,
            startTime: '09:15',
            endTime: '19:00',
            baseHeight: 150,
            lunchStart: '12:50',
            lunchEnd: '14:20',
            horarios: [
              {hora: '09:15', horaTxt: '09h15', size: .5},
              {hora: '09:30', horaTxt: '09h30', size: 1},
              {hora: '10:10', horaTxt: '10h10', size: 1},
              {hora: '10:50', horaTxt: '10h50', size: 1},
              {hora: '11:30', horaTxt: '11h30', size: 1},
              {hora: '12:10', horaTxt: '12h10', size: 1},
              {hora: '12:50', horaTxt: '<small class="lunchTime">12h50 <br>às<br> 14h20</small>', size: .5},
              {hora: '14:30', horaTxt: '14h30', size: 1},
              {hora: '15:10', horaTxt: '15h10', size: 1},
              {hora: '16:00', horaTxt: '16h00', size: 1},
              {hora: '16:40', horaTxt: '16h40', size: 1},
              {hora: '17:20', horaTxt: '17h20', size: 1},
              {hora: '18:10', horaTxt: '18h10', size: 1},
              {hora: '18:30', horaTxt: '18h30', size: .5},
            ],
            intervalos: [
              {hora: '09:15', horaTxt: 'Abertura do evento', size: .5},
              {hora: '10:50', horaTxt: 'Intervalo para negócios', size: 1},
              {hora: '12:50', horaTxt: 'Intervalo de almoço', size: .5},
              {hora: '16:00', horaTxt: 'Coffee Break e networking', size: 1},
              {hora: '18:30', horaTxt: 'Encerramento', size: .5}
            ]
        }
      },
      mounted: function() {
        this.id = this._uid;
      },
      filters: {
        formatTimeFromDate: function(dtStr) {
          let d = new Date(dtStr);
          let hora = ("0" + d.getHours()).slice(-2) + "h" + ("0" + d.getMinutes()).slice(-2);
          return hora;
        }
      },
      computed: {
        _horarios() {
          // transform the start_time and end_time to Date for easier comparison.
          let startTime = new Date(`1/1/1970 ${this.startTime}`);
          const endTime = new Date(`1/1/1970 ${this.endTime}`);

          const lunchStart = new Date(`1/1/1970 ${this.lunchStart}`);
          const lunchEnd = new Date(`1/1/1970 ${this.lunchEnd}`);

          // This interval is in Minutes.
          const interval = 40 * 60000;

          // The result array where we will store the time
          const results = [];

          let lunchSet = false;
          while (startTime.getTime() <= endTime.getTime()) {
            if (startTime.getTime() >= lunchStart.getTime() && startTime.getTime() < lunchEnd.getTime()) {
              if (!lunchSet) {
                results.push(``);
                results.push(`${this.formatTime(lunchStart)} ${this.formatTime(lunchEnd)}`);
                lunchSet = true;
              }
              startTime = new Date(startTime.getTime() + interval);
              continue;
            }
            results.push(`${this.formatTime(startTime)}`);
            startTime = new Date(startTime.getTime() + interval);
          }

          return results;
        },
        lunchIndex() {
          let vm = this;
          return _.findIndex(this.horarios, function(o) { return o.hora == vm.lunchStart; });
        },
        topPositionLunch() {
          return this.lunchIndex*this.baseHeight+"px";
        },
        heightLunch() {
          return this.baseHeight/2+"px";
        },
        startIndex() {
          let vm = this;
          return _.findIndex(this.horarios, function(o) { return o.hora == vm.startTime; });
        },
        topPositionStart() {
          return "55px";
        },
        heightStart() {
          return this.baseHeight/2+"px";
        },
        palcosByName() {
          return _.sortBy(this.palcos, function(o) { return o.title });
        }

      },
      methods: {
        formatTime(d) {
          let hora = ("0" + d.getHours()).slice(-2) + "h" + ("0" + d.getMinutes()).slice(-2);
          return hora;
        },
        getTalksByTrack(track) {

          //console.log(this.talks);
          let vm = this;
          let returnTalks = this.talks.filter(function(talk) {

            var talkDate = vm.$moment(talk.date_start);
            var talkDay = 0;
            var isFullDay = false;

            if (talk.date_start.includes('Fullday')) {
              talkDay = vm.$moment(talk.date_start.substring(0,10)).format('D');
              isFullDay = true;
              talk.isFullDay = true;
            }
            else {
              talkDay = talkDate.format('D');
            }

            if (!talkDate.isValid() && !isFullDay) {
              return false;
            }

            var calendarDate = vm.$moment(vm.dia).format('D');

            return track.id == talk.trackSlug && (talkDay == calendarDate || isFullDay);
          }).reverse();

          return _.sortBy(returnTalks, [function(o) {return o.date_start;}]);

        },
        topPositionEvento(talk) {

          let talkMinutes = parseInt(this.$moment(talk.date_start).format('mm'));
          //let format = (talkMinutes == 0 || talkMinutes == 30)?'kk[h]mm':((talkMinutes>30)?'kk[h30]':'kk[h00]');
          let format = 'kk';
          let talkTime = this.$moment(talk.date_start).format(format);
          let aIndex = [];
          let aMinutes = [];
          //let difMinuts = (talkMinutes == 0 || talkMinutes == 30)?0:((talkMinutes>30)?talkMinutes-30:talkMinutes);

          let vm = this;
          this.horarios.map(function(horario,index) {

            const dHorario = new Date(`1/1/1970 ${horario.hora}`);
            const hora = vm.$moment(dHorario).format(format);
            const minutos = vm.$moment(dHorario).format('mm');

            if (hora == talkTime) {
              if (minutos == talkMinutes) {
                aIndex = [];
                aMinutes = [];
              }
              aIndex.push(index);
              aMinutes.push(minutos);
            }
          });

          let difMinuts = talkMinutes - aMinutes[0];

          let subtract = this.baseHeight/2;

          if (aIndex[0] > this.lunchIndex) {
            subtract = this.baseHeight;
          }
          else if (aIndex[0] == 0) {
            subtract = 0;
          }

          return aIndex[0]*this.baseHeight+(this.baseHeight*difMinuts/30)-subtract+"px";
        },
        heightEvento(talk) {
          let diff = this.$moment(talk.date_end).diff(this.$moment(talk.date_start));

          diff = diff/1000/60;

          return (diff/80*this.baseHeight*2)+"px";
        },
        topPositionIntervalo(intervalo) {

          let aIndex = [];

          this.horarios.filter(function(horario,index) {

            if (horario.hora == intervalo.hora) {
              aIndex.push(index);
            }

          });

          let subtract = 15;

          if (aIndex[0] > this.lunchIndex) {
            subtract += this.baseHeight/2;
          }

          let top = aIndex[0]*this.baseHeight-subtract;


          return (top<=0?55:top-5)+"px";

        },
        heightIntervalo(intervalo) {
          return this.baseHeight*intervalo.size+"px";
        },
        addUserTalk(talk) {
          talk.speakers.forEach(speaker => {
            speaker.talk = null;
          });

          let theTalk = _.find(this.talks, {id: talk.id});
          const theTalkIndex = _.findIndex(this.talks, {id: talk.id});

          theTalk.talkAdded = true;

          this.$set(this.talks, theTalkIndex, theTalk);

          this.$addUserTalk(talk);
        },
        removeUserTalk(talk) {
          let theTalk = _.find(this.talks, {id: talk.id});
          const theTalkIndex = _.findIndex(this.talks, {id: talk.id});

          theTalk.talkAdded = false;

          this.$set(this.talks, theTalkIndex, theTalk);

          this.$removeUserTalk(talk.id);
        },
        userHaveTalk(talk) {
          return this.$userHaveTalk(talk);
        },
        openTalk(talk) {
          this.$refs.ModalTalk.openTalk(talk);
        },
        openModalTrackTalks(track, dia) {
            this.$refs.ModalTrackTalks.openTalks(track, dia, this.talks);
        }
      }
   }
  </script>

  <style lang="scss">


</style>
